import { render } from "./secondSection.vue?vue&type=template&id=a6c42140"
import script from "./secondSection.vue?vue&type=script&lang=js"
export * from "./secondSection.vue?vue&type=script&lang=js"

import "./secondSection.vue?vue&type=style&index=0&id=a6c42140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__